// The installed-app surfaces the workspace mounts once: the after-update «Novedades de esta versión»
// sheet and the share-target picker. (The "new version" banner sits in the sidebar's notice slot —
// UpdateBanner — and notification actions live in ui/features/notifications.)
import { AfterUpdateReleaseNotes } from './releaseNotes';
import { ShareTargetHost } from './ShareTargetHost';

export function PwaHost({ selectedChannelId, modalOpen }: { selectedChannelId: string | null; modalOpen: boolean }) {
  return (
    <>
      <ShareTargetHost selectedChannelId={selectedChannelId} />
      {/* Never stacked on another modal (§11.3): it waits until the screen is clear. */}
      <AfterUpdateReleaseNotes blocked={modalOpen} />
    </>
  );
}
